// Modified from https://github.com/palmerhq/radio-group
import { Children, useCallback, useMemo } from 'react';
import shortid from 'shortid';

import { RadioGroupContext, RadioGroupProps } from './shared';

const RadioGroup = <V extends unknown>({
  children,
  labelledBy,
  onChange,
  value,
  ...props
}: RadioGroupProps<unknown>) => {
  const groupId = useMemo(() => shortid(), []);

  const setChecked = useCallback(
    (v: V) => {
      if (onChange) {
        onChange(v);
      }
    },
    [onChange]
  );

  const otherRadioValues = Children.map(children, child => child.props.value);

  const ctx = useMemo(
    () => ({
      groupId,
      otherRadioValues,
      setChecked,
      value
    }),
    [groupId, otherRadioValues, setChecked, value]
  );

  return (
    <RadioGroupContext.Provider value={ctx}>
      <div {...props} aria-labelledby={labelledBy} role="radiogroup">
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
};

export default RadioGroup;
